import { Component } from 'react';
// import store, { initialState } from '.';
// import {
//   NAME_INPUT, AGE_PICKER, LIFE_STAGE_CAROUSEL,
// } from '../constants';

class SavedStateHandler extends Component {
    handleKeyUp = (e) => {
      if (e.which === 49) {
        console.log('Shortcut detected: ', 1);
        // initialState.inputComponent = NAME_INPUT;
        // store.dispatch({ type: 'LOAD_STATE', savedState: initialState });
      }
      if (e.which === 50) {
        console.log('Shortcut detected: ', 2);
        // initialState.inputComponent = AGE_PICKER;
        // store.dispatch({ type: 'LOAD_STATE', savedState: initialState });
      }
      if (e.which === 51) {
        console.log('Shortcut detected: ', 3);
        // initialState.inputComponent = LIFE_STAGE_CAROUSEL;
        // store.dispatch({ type: 'LOAD_STATE', savedState: initialState });
      }
    }

    componentDidMount = () => {
      document.addEventListener('keyup', this.handleKeyUp);
    }

    render() {
      return null;
    }
}

export default SavedStateHandler;
